export default "__VITE_ASSET__BYQ04Gtu__"